/* ================================================================
   MOLONT — Theme JavaScript v1.0
================================================================ */

(function() {
  'use strict';

  // ── CART ────────────────────────────────────────────────────
  const Cart = {
    drawer: document.querySelector('[data-cart-drawer]'),
    overlay: document.querySelector('[data-cart-overlay]'),
    itemsContainer: document.querySelector('[data-cart-items]'),
    totalEl: document.querySelector('[data-cart-total]'),

    open() {
      this.drawer?.classList.add('open');
      this.overlay?.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer?.classList.remove('open');
      this.overlay?.classList.remove('open');
      document.body.style.overflow = '';
    },

    async add(variantId, quantity = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        if (!res.ok) throw new Error('Could not add to cart');
        await this.refresh();
        this.open();
      } catch (e) {
        console.error('Cart add error:', e);
        alert('Sorry, this item could not be added. Please try again.');
      }
    },

    async update(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!res.ok) throw new Error('Could not update cart');
        await this.refresh();
      } catch (e) {
        console.error('Cart update error:', e);
      }
    },

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.renderItems(cart);
        this.updateCount(cart.item_count);
      } catch (e) {
        console.error('Cart refresh error:', e);
      }
    },

    renderItems(cart) {
      if (!this.itemsContainer) return;
      if (cart.item_count === 0) {
        this.itemsContainer.innerHTML = '<div class="m-cart-empty">Your cart is empty.</div>';
        if (this.totalEl) this.totalEl.textContent = '£0.00';
        return;
      }
      const fmt = (p) => '£' + (p / 100).toFixed(2);
      this.itemsContainer.innerHTML = cart.items.map(item => `
        <div class="m-cart-item" data-item-key="${item.key}">
          <div class="m-cart-item__img">
            ${item.featured_image?.url
              ? `<img src="${item.featured_image.url.replace('.jpg', '_150x.jpg').replace('.webp', '_150x.webp')}" alt="${item.title}" width="72" height="72" loading="lazy">`
              : ''}
          </div>
          <div>
            <div class="m-cart-item__name">${item.product_title}</div>
            <div class="m-cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div class="m-cart-item__bottom">
              <div class="m-cart-item__qty">
                <button class="m-cart-item__qty-btn" data-qty-decrease="${item.key}">−</button>
                <span>${item.quantity}</span>
                <button class="m-cart-item__qty-btn" data-qty-increase="${item.key}">+</button>
              </div>
              <span class="m-cart-item__price">${fmt(item.line_price)}</span>
            </div>
          </div>
        </div>
      `).join('');
      if (this.totalEl) this.totalEl.textContent = fmt(cart.total_price);
      this.bindQtyButtons();
    },

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    bindQtyButtons() {
      this.itemsContainer?.querySelectorAll('[data-qty-decrease]').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.qtyDecrease;
          const item = this.itemsContainer.querySelector(`[data-item-key="${key}"]`);
          const qty = parseInt(item?.querySelector('.m-cart-item__qty span')?.textContent || '1');
          Cart.update(key, Math.max(0, qty - 1));
        });
      });
      this.itemsContainer?.querySelectorAll('[data-qty-increase]').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.qtyIncrease;
          const item = this.itemsContainer.querySelector(`[data-item-key="${key}"]`);
          const qty = parseInt(item?.querySelector('.m-cart-item__qty span')?.textContent || '1');
          Cart.update(key, qty + 1);
        });
      });
    },

    init() {
      document.querySelectorAll('[data-cart-toggle]').forEach(el => {
        el.addEventListener('click', () => {
          this.drawer?.classList.contains('open') ? this.close() : this.open();
        });
      });
      this.overlay?.addEventListener('click', () => this.close());
      this.bindQtyButtons();
    }
  };

  // ── MOBILE NAV ───────────────────────────────────────────────
  const Nav = {
    mobileNav: document.querySelector('[data-mobile-nav]'),

    init() {
      document.querySelectorAll('[data-nav-toggle]').forEach(el => {
        el.addEventListener('click', () => {
          const open = this.mobileNav?.classList.toggle('open');
          document.body.style.overflow = open ? 'hidden' : '';
          document.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded', String(open));
        });
      });
    }
  };

  // ── PRODUCT PAGE ─────────────────────────────────────────────
  // ATC, size selection, gallery, and accordions are handled by
  // the inline script in sections/main-product.liquid.
  // This stub prevents duplicate event listeners.
  const ProductPage = {
    init() {
      // Intentionally empty — product page JS is self-contained
      // in main-product.liquid to avoid duplicate event listeners.
    }
  };

  // ── COLLECTION FILTERS ───────────────────────────────────────
  const CollectionFilters = {
    init() {
      document.querySelectorAll('[data-filter]').forEach(btn => {
        btn.addEventListener('click', () => {
          document.querySelectorAll('[data-filter]').forEach(b => b.classList.remove('m-filter--active'));
          btn.classList.add('m-filter--active');
        });
      });
    }
  };

  // ── SEARCH ───────────────────────────────────────────────────
  const Search = {
    init() {
      document.querySelector('[data-search-toggle]')?.addEventListener('click', () => {
        window.location.href = '/search';
      });
    }
  };

  // Expose Cart globally so product page inline JS can call refresh
  window.MolontCart = Cart;

  // ── INIT ─────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    Cart.init();
    Nav.init();
    ProductPage.init();
    CollectionFilters.init();
    Search.init();
  });

})();
